import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  webhooks: [],
};

const webhookSlice = createSlice({
  name: "webhook",
  initialState,
  reducers: {
    setWebhooks(state, action) {
      state.webhooks = action.payload;
    },
    addWebhook(state, action) {
      const newWebhook = action.payload;
      return {
        ...state,
        webhooks: [...state.webhooks, newWebhook],
      };
    },
    updateWebhook(state, action) {
      const { id, webhookDetails } = action.payload;
      const updatedWebhooks = state.webhooks.map((webhook) => {
        if (webhook.id === id) {
          return webhookDetails;
        }
        return webhook;
      });
      return {
        ...state,
        webhooks: updatedWebhooks,
      };
    },
    removeWebhook(state, action) {
      const idToRemove = action.payload;
      const newWebhooks = state.webhooks.filter(
        (webhook) => webhook.id !== idToRemove
      );
      return {
        ...state,
        webhooks: newWebhooks,
      };
    },
  },
});

export function getWebhooks() {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/webhooks`,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(webhookSlice.actions.setWebhooks(response.data.data));
      return Promise.resolve(response.data.message);
    } catch (error) {
      dispatch(webhookSlice.actions.setWebhooks([]));
      return Promise.reject(error.message);
    }
  };
}

export function createWebhook({ data }) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/webhooks`,
        data,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(webhookSlice.actions.addWebhook(response.data.data));
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export function updateWebhook({ id, data }) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/webhooks/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(
        webhookSlice.actions.updateWebhook({
          id: id,
          webhookDetails: response.data.data,
        })
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export function toggleActive({ id, isActive }) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/webhooks/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
          params: {
            isActive: isActive,
          },
        }
      );
      dispatch(
        webhookSlice.actions.updateWebhook({
          id: id,
          webhookDetails: response.data.data,
        })
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export function deleteWebhook({ id }) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/webhooks/${id}`,

        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(webhookSlice.actions.deleteWebhook(id));
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export default webhookSlice.reducer;
